/** Create an array with `n` elements, each generated by the function `fn`. */
function range(n, fn) {
    return Array.from({ length: n }, (_, i) => fn(i));
}
function sum(numbers) {
    return numbers.reduce((acc, n) => acc + n, 0);
}
function average(numbers) {
    return numbers.length === 0 ? 0 : sum(numbers) / numbers.length;
}
/**
 * Takes the average of the delta between every pair of numbers in the array.
 * The array must be at least length 2 to produce a meaningful result.
 */
function averageDelta(numbers) {
    const n = numbers.length;
    if (n < 2)
        return 0;
    const deltas = [];
    for (let i = 1; i < n; ++i) {
        deltas.push(numbers[i] - numbers[i - 1]);
    }
    return average(deltas);
}
/** Wrap value in an array if it isn't one already. */
function asArray(value) {
    return Array.isArray(value) ? value : [value];
}
/** Remove the first occurrence of a value from an array, mutating it in place. */
function removeByValue(array, value) {
    const index = array.indexOf(value);
    if (index === -1)
        return;
    array.splice(index, 1);
}
/**
 * Find the index of the last element in the array that passes the predicate test.
 * If no element is found, returns `-1`.
 *
 * Polyfill for `Array#findLastIndex` (ES2023) since our target is ES2022.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findLastIndex
 */
function findLastIndex(array, predicate) {
    for (let i = array.length - 1; i >= 0; --i) {
        if (predicate(array[i], i, array))
            return i;
    }
    return -1;
}

export { asArray, average, averageDelta, findLastIndex, range, removeByValue, sum };
//# sourceMappingURL=array.js.map
